import { logSearchError } from '../util/clientLogger'

const clientErrorRedirect = (errorMessage, location = globalThis.window.location) => {
  const urlParams = new URLSearchParams(location.search)

  const cartKey = urlParams.get('cart-key')
  if (cartKey) {
    logSearchError('Package Search Cart Error', errorMessage)

    const pkgErrorQueryParams = new URLSearchParams({
      'redirect-source': 'error',
      message: 'PKG_FLIGHT_CLIENT_ERROR',
    })

    const isAgentMode = window.PCLN_BOOTSTRAP_DATA?.featureToggles?.whiteLabel?.agentMode

    location.assign(
      `${isAgentMode ? '/shop/search/' : '/vacationpackages/'}?${pkgErrorQueryParams.toString()}`
    )
    return
  }

  const offerToken = urlParams.get('offer-token')
  const uspCacheKey = urlParams.get('usp-cache-key')
  const userActionType = urlParams.get('userActionType')
  const params = {
    'num-adults': urlParams.get('num-adults') || 1,
    'num-children': urlParams.get('num-children') || 0,
    'num-infants': urlParams.get('num-infants') || 0,
  }

  if (uspCacheKey) {
    params['usp-cache-key'] = uspCacheKey
  }
  if (offerToken) {
    params['offer-token'] = offerToken
  }
  if (userActionType) {
    params['userActionType'] = userActionType
  }

  const redirectParams = new URLSearchParams(params).toString()

  const url = `/m/fly/search/noresults?${redirectParams}`

  location.assign(url)
}

export { clientErrorRedirect }
